import { Action } from '@ngrx/store';
import { NotificationsSettings, Preferences } from '../../global/interfaces';
import { ReportsOptions } from './profile.models';

export enum ActionTypes {
  SAVE_DATA_TABLE_CONFIG             = '[Profile] Save Data Tables Config Action',
  SAVE_DATA_TABLE_CONFIG_FAILED      = '[Profile] Save Data Tables Config Failed Action',

  SAVE_NOTIFICATIONS_SETTINGS        = '[Profile] Save Notifications Settings Action',
  SAVE_NOTIFICATIONS_SETTINGS_FAILED = '[Profile] Save Notifications Settings Failed Action',

  SAVE_REPORTS_CONFIG                = '[Profile] Save Reports Config Action',
  SAVE_REPORTS_CONFIG_FAILED         = '[Profile] Save Reports Config Failed Action',


}

export class SaveDataTablesConfigAction implements Action {
  readonly type = ActionTypes.SAVE_DATA_TABLE_CONFIG;

  public constructor(public payload: Preferences) {
  }
}

export class SaveDataTablesConfigFailedAction implements Action {
  readonly type = ActionTypes.SAVE_DATA_TABLE_CONFIG_FAILED;

  public constructor(public payload: any) {
  }
}

export class SaveNotificationsSettingsAction implements Action {
  readonly type = ActionTypes.SAVE_NOTIFICATIONS_SETTINGS;

  public constructor(public payload: NotificationsSettings) {
  }
}

export class SaveNotificationsSettingsFailedAction implements Action {
  readonly type = ActionTypes.SAVE_NOTIFICATIONS_SETTINGS_FAILED;

  public constructor(public payload: any) {
  }
}

export class SaveReportsConfigAction implements Action {
  readonly type = ActionTypes.SAVE_REPORTS_CONFIG;

  public constructor(public payload: ReportsOptions) {
  }
}

export class SaveReportsConfigFailedAction implements Action {
  readonly type = ActionTypes.SAVE_REPORTS_CONFIG_FAILED;

  public constructor(public payload: any) {
  }
}


export type Actions =
  SaveDataTablesConfigAction |
  SaveDataTablesConfigFailedAction |
  SaveNotificationsSettingsAction |
  SaveNotificationsSettingsFailedAction |
  SaveReportsConfigAction |
  SaveReportsConfigFailedAction;
